<template>
  <div>
    <button class="flex min-h-0 gap-3 p-0" @click="openProductSizeGuide">
      <IconCoatHanger v-if="!hideIcon" class="h-5 w-7" />
      <span class="text-base underline">{{
        $t('pdp.size_picker.size-advisor')
      }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
const { hideIcon } = defineProps<{
  hideIcon?: boolean
}>()

const { openProductSizeGuide } = useUiState()
</script>
